import classnames from 'classnames'
import styles from './styles.module.scss'

export const MobileHeaderProgress = ({
    getStepValue,
    flowSteps,
    activeStep,
    onStepClick,
    passedStep,
    stepPrefix,
    t,
    stepValues,
}) => (
    <div className="d-flex justify-content-between">
        <div className="d-flex">
            {flowSteps.map((step, index) => (
                <button
                    key={index}
                    className={classnames(styles.progressStep, {
                        [styles.active]: activeStep === step,
                        [styles.disabled]: index > flowSteps.indexOf(activeStep),
                    })}
                    onClick={() => index < flowSteps.indexOf(activeStep) && onStepClick(step)}>
                    <div className={styles.stepDescription}>
                        <span className={classnames(styles.stepNumber, passedStep(index) && styles.passedStepNumber)}>
                            {index + 1}
                        </span>
                        <span className={classnames(styles.stepName, passedStep(index) && styles.passedStepName)}>
                            {t(`${stepPrefix}.purchase.${step}`)}
                        </span>
                    </div>
                    {getStepValue(stepValues, step)}
                </button>
            ))}
        </div>
        <div className={styles.stepLine}></div>
        <div>
            <span className={styles.stepNameXC}>{t(`${stepPrefix}.purchase.${activeStep}`)}</span>
        </div>
    </div>
)
